export default function Hero() {
  return (
    <section id="top" className="relative min-h-[820px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=South%20Florida%20coastal%20aerial%20view%20of%20elegant%20gated%20community%20with%20palm%20trees%20swimming%20pool%20and%20mediterranean%20style%20homes%20under%20warm%20golden%20hour%20light%2C%20cinematic%20editorial%20photography%2C%20soft%20haze%20subtle%20teal%20and%20amber%20tones%2C%20aspirational%20architectural%20photography%20with%20wide%20composition%20and%20lush%20green%20landscaping&width=2000&height=1200&seq=hero-assoc-integrity-01&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
      <div className="absolute inset-0 hero-grid-mask opacity-40" />

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12 md:pb-32">
        <div className="fade-up max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-background-50/10 border border-background-50/25 backdrop-blur-sm rounded-full px-4 py-1.5 text-background-50 text-xs font-medium tracking-wide">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
            SERVING SOUTH FLORIDA HOAs, CONDOS AND 55+ COMMUNITIES
          </div>

          <h1 className="mt-8 font-heading text-background-50 text-4xl sm:text-5xl md:text-7xl leading-[1.05] md:leading-[1.02] font-semibold tracking-tight">
            Website compliance,
            <br />
            <span className="italic text-accent-300">handled with integrity.</span>
          </h1>

          <p className="mt-6 max-w-2xl text-background-100 text-base sm:text-lg md:text-xl leading-relaxed">
            We build, audit and maintain association websites that meet
            <span className="text-background-50 font-medium"> Florida Statute 720.303 and 718.111</span>,
            <span className="text-background-50 font-medium"> ADA/WCAG 2.2</span> and
            <span className="text-background-50 font-medium"> HOPA 55+ housing</span> requirements, giving your
            board total peace of mind and your residents the transparency Florida law demands.
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="bg-accent-500 hover:bg-accent-600 text-background-50 text-base font-semibold px-7 py-4 rounded-md flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap transition-colors"
            >
              Get Your Free Compliance Audit
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#process"
              className="bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-base font-semibold px-7 py-4 rounded-md flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap transition-colors"
            >
              How It Works
            </a>
          </div>

          <div className="mt-10 md:mt-14 flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-4 sm:gap-6 md:gap-10">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/10 border border-background-50/20 flex-shrink-0">
                <i className="ri-scales-3-line text-background-50 text-lg" />
              </div>
              <div>
                <div className="text-background-50 font-semibold text-sm">FL Statute Ready</div>
                <div className="text-background-100 text-xs">720.303 · 718.111 · 719.104</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/10 border border-background-50/20 flex-shrink-0">
                <i className="ri-eye-line text-background-50 text-lg" />
              </div>
              <div>
                <div className="text-background-50 font-semibold text-sm">WCAG 2.2 AA</div>
                <div className="text-background-100 text-xs">ADA Title III conformance</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/10 border border-background-50/20 flex-shrink-0">
                <i className="ri-group-2-line text-background-50 text-lg" />
              </div>
              <div>
                <div className="text-background-50 font-semibold text-sm">HOPA 55+</div>
                <div className="text-background-100 text-xs">Fair Housing Act compliant</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
  );
}